/**
 * Registers public/service-worker.js — what makes the app installable
 * (Chrome/Edge require a registered service worker with a fetch handler,
 * a valid manifest, and HTTPS before they'll offer "Install app"/"Add to
 * desktop"). Production only: a service worker in dev would cache stale
 * bundles across hot reloads, which is more confusing than useful.
 */
export function register() {
  if (process.env.NODE_ENV !== "production") return;
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .catch(() => {
        /* Installability just won't be offered — nothing else in the app
           depends on this succeeding. */
      });
  });
}

export function unregister() {
  if (!("serviceWorker" in navigator)) return;
  navigator.serviceWorker.ready
    .then((registration) => registration.unregister())
    .catch(() => {});
}
